import { useEffect } from 'react';

import useCurrentCurrency from 'canvas_states/currency/useCurrentCurrency';
import useAppConfig from 'canvas_states/config/useAppConfig';
import useCurrentLanguage from 'canvas_states/language/useCurrentLanguage';
import type { PartnerInfo } from '../../utils/urls/useUrlInfo';
import useTranslation, { fetchTextkeys } from 'canvas_states/translation/useTranslation';

export interface SettingsInitializerProps extends Partial<PartnerInfo> {
  children: React.ReactNode;
}

const SettingsInitializer: React.FC<SettingsInitializerProps> = ({
  children,
  pid,
  requestId,
  addChannelSource,
  overrideChannelSource,
}) => {
  const { config } = useAppConfig().states;

  const { initializeCurrentCurrency } = useCurrentCurrency().actions;
  const {
    actions: { initializeCurrentLanguage },
    states: { currentLanguage },
  } = useCurrentLanguage();

  useEffect(() => {
    if (pid && config) {
      initializeCurrentLanguage(config, pid, requestId, addChannelSource ?? overrideChannelSource ?? undefined);
      initializeCurrentCurrency(config);
    }
  }, [pid, config]);

  const { initialized } = useTranslation().states;

  // in case then requestId, pid, or channelsource change, we want to refetch the textkeys.
  useEffect(() => {
    if (initialized && pid) {
      fetchTextkeys(pid, currentLanguage.code, requestId, addChannelSource ?? overrideChannelSource ?? undefined).catch(
        console.error,
      );
    }
  }, [pid, requestId, addChannelSource ?? overrideChannelSource]);

  return <>{children}</>;
};
export default SettingsInitializer;
